export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="96" height="96" rx="20" fill="#064E3B" />
    <path
      d="M32 68V30l28 38V16"
      stroke="#F8FAFC"
      strokeWidth="8.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51 26l9-12 9 12"
      stroke="#D97706"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function Logo({ light = false }) {
  return (
    <span className="flex items-center gap-2.5">
      <LogoMark className="h-9 w-9 shrink-0" />
      <span className="leading-none">
        <span
          className={`block font-display text-lg font-bold tracking-tight ${
            light ? "text-white" : "text-forest"
          }`}
        >
          NKB Traders
        </span>
        <span
          className={`mt-1 block font-mono text-[9px] font-medium uppercase tracking-[0.32em] ${
            light ? "text-white/60" : "text-slate-500"
          }`}
        >
          Export House
        </span>
      </span>
    </span>
  );
}
